import JSONAPISerializer from '@ember-data/serializer/json-api';

export default JSONAPISerializer.extend({
    attrs: {
        verified: {serialize: false},
        isPublished: {serialize: false},
        onPlatform: {serialize: false}
    }
});
